module.exports = __webpack_public_path__ + "static/img/fangxiu.47f7b940.svg";